import React, { useEffect, useState } from 'react';
import axios from 'axios';
import SellerLayout from './SellerLayout';

const SellerMemberDetail = () => {
  const [loading, setLoading] = useState(true);

  const [shopName, setShopName] = useState('');
  const [member, setMember] = useState(null);
  const [summary, setSummary] = useState({});
  const [orders, setOrders] = useState([]);
  const [coupons, setCoupons] = useState([]);
  
  // 백엔드에서 새로 추가된 상세 리스트들을 저장할 State 추가
  const [reviews, setReviews] = useState([]);
  const [qnas, setQnas] = useState([]);
  const [wishlists, setWishlists] = useState([]);

  // 탭 상태 관리 ('info', 'orders', 'coupons', 'reviews', 'qna', 'wishlist')
  const [activeTab, setActiveTab] = useState('info');

  useEffect(() => {
    const fetchData = async () => {
      try {
        const id = new URLSearchParams(window.location.search).get('id');

        const res = await axios.get(
          `/api/seller/member/detail-data?id=${encodeURIComponent(id)}`,
          { withCredentials: true }
        );

        if (res.data?.ok) {
          setShopName(res.data.shop_name || '');
          setMember(res.data.member);
          setSummary(res.data.summary || {});
          setOrders(res.data.orders || []);
          setCoupons(res.data.coupons || []);
          
          // 백엔드에서 받은 실제 상세 데이터들 매핑
          setReviews(res.data.reviews || []);
          setQnas(res.data.qnas || []);
          setWishlists(res.data.wishlists || []);
        }
      } catch (err) {
        alert(err?.response?.data?.error || '회원정보를 불러오지 못했습니다.');
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  if (loading) {
    return (
      <SellerLayout shopName={shopName}>
        <div style={styles.loading}>로딩중...</div>
      </SellerLayout>
    );
  }

  return (
    <SellerLayout shopName={shopName}>
      <div style={styles.container}>
        <h2 style={styles.title}>회원 상세</h2>

        {/* 전체 탭 메뉴 구성 */}
        <div style={styles.tabs}>
          <button
            onClick={() => setActiveTab('info')}
            style={activeTab === 'info' ? styles.activeTab : styles.tab}
          >
            회원정보
          </button>

          <button
            onClick={() => setActiveTab('orders')}
            style={activeTab === 'orders' ? styles.activeTab : styles.tab}
          >
            주문내역 ({summary.order_count || 0})
          </button>

          <button
            onClick={() => setActiveTab('coupons')}
            style={activeTab === 'coupons' ? styles.activeTab : styles.tab}
          >
            쿠폰 ({summary.coupon_count || 0})
          </button>

          <button
            onClick={() => setActiveTab('reviews')}
            style={activeTab === 'reviews' ? styles.activeTab : styles.tab}
          >
            리뷰 ({summary.review_count || 0})
          </button>

          <button
            onClick={() => setActiveTab('qna')}
            style={activeTab === 'qna' ? styles.activeTab : styles.tab}
          >
            문의 ({summary.qna_count || 0})
          </button>

          <button
            onClick={() => setActiveTab('wishlist')}
            style={activeTab === 'wishlist' ? styles.activeTab : styles.tab}
          >
            찜 ({summary.wishlist_count || 0})
          </button>
        </div>

        {/* 1. 회원정보 탭 */}
        {activeTab === 'info' && (
          <div style={styles.card}>
            <p><b>아이디</b> : {member?.id}</p>
            <p><b>닉네임</b> : {member?.nickname}</p>
            <p><b>이메일</b> : {member?.email || '-'}</p>
            <p><b>전화번호</b> : {member?.phone || '-'}</p>
            <p><b>가입방식</b> : {member?.social || '일반회원'}</p>
            <p><b>가입일</b> : {member?.created_at || '-'}</p>
          </div>
        )}

        {/* 2. 주문내역 탭 */}
        {activeTab === 'orders' && (
          <table style={styles.table}>
            <thead>
              <tr>
                <th style={styles.th}>주문번호</th>
                <th style={styles.th}>주문자</th>
                <th style={styles.th}>정상가</th>
                <th style={styles.th}>상품할인</th>
                <th style={styles.th}>쿠폰할인</th>
                <th style={styles.th}>배송비</th>
                <th style={styles.th}>결제금액</th>
                <th style={styles.th}>상태</th>
              </tr>
            </thead>
            <tbody>
              {orders.length === 0 ? (
                <tr>
                  <td colSpan="5" style={styles.empty}>
                    주문내역이 없습니다.
                  </td>
                </tr>
              ) : (
                orders.map((row) => {

                  const originalPrice =
                    Number(row.total_price || 0) +
                    Number(row.product_discount_amount || 0);
              
                  return (
                    <tr
                    key={row.id}
                    onClick={() =>
                      (window.location.href = `/seller/order/view?id=${row.id}`)
                    }
                    style={{ cursor: 'pointer' }}
                    >
                      <td style={styles.td}>{row.id}</td>
              
                      <td style={styles.td}>
                        {row.buyer_name}
                      </td>
              
                      <td style={styles.td}>
                        {originalPrice.toLocaleString()}원
                      </td>
              
                      <td style={styles.td}>
                        -{Number(
                          row.product_discount_amount || 0
                        ).toLocaleString()}원
                      </td>
              
                      <td style={styles.td}>
                        -{Number(
                          row.discount_amount || 0
                        ).toLocaleString()}원
                      </td>

                      <td style={styles.td}>
                        +{Number(
                          row.delivery_cost || 0
                        ).toLocaleString()}원
                      </td>
              
                      <td style={styles.td}>
                        <b>
                          {Number(
                            row.result_price || 0
                          ).toLocaleString()}원
                        </b>
                      </td>
              
                      <td style={styles.td}>
                        {row.status}
                      </td>
                    </tr>
                  );
                })
              )}
            </tbody>
          </table>
        )}

        {/* 3. 쿠폰 탭 */}
        {activeTab === 'coupons' && (
          <table style={styles.table}>
            <thead>
              <tr>
                <th style={styles.th}>쿠폰명</th>
                <th style={styles.th}>할인 혜택</th>
                <th style={styles.th}>최소 주문금액</th>
                <th style={styles.th}>사용 여부</th>
                <th style={styles.th}>사용일 / 유효기간</th>
              </tr>
            </thead>
            <tbody>
              {coupons.length === 0 ? (
                <tr>
                  <td colSpan="5" style={styles.empty}>
                    보유한 쿠폰이 없습니다.
                  </td>
                </tr>
              ) : (
                coupons.map((c) => (
                  <tr key={c.id}>
                    <td style={styles.td}><b>{c.coupon_name}</b></td>
                    <td style={styles.td}>
                      {c.discount_type === 'percent'
                        ? `${c.discount_value}% 할인`
                        : `${Number(c.discount_value || 0).toLocaleString()}원 할인`}
                    </td>
                    <td style={styles.td}>
                      {Number(c.min_order_price || 0).toLocaleString()}원 이상 구매 시
                    </td>
                    <td style={styles.td}>
                      <span style={c.used_yn === 'Y' ? styles.badgeUsed : styles.badgeUnused}>
                        {c.used_yn === 'Y' ? '사용완료' : '사용가능'}
                      </span>
                    </td>
                    <td style={styles.td}>
                      {c.used_yn === 'Y' ? (
                        <span style={{ color: '#888' }}>{c.used_at} (사용됨)</span>
                      ) : (
                        <span>{c.start_date} ~ {c.end_date}</span>
                      )}
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        )}

        {/* 4. 리뷰 탭 (실제 목록 구현 완료) */}
        {activeTab === 'reviews' && (
          <table style={styles.table}>
            <thead>
              <tr>
                <th style={styles.th} style={{ ...styles.th, width: '25%' }}>상품 정보</th>
                <th style={styles.th} style={{ ...styles.th, width: '15%' }}>평점</th>
                <th style={styles.th} style={{ ...styles.th, width: '45%' }}>리뷰 내용</th>
                <th style={styles.th} style={{ ...styles.th, width: '15%' }}>작성일</th>
              </tr>
            </thead>
            <tbody>
              {reviews.length === 0 ? (
                <tr>
                  <td colSpan="4" style={styles.empty}>작성된 리뷰가 없습니다.</td>
                </tr>
              ) : (
                reviews.map((r) => (
                  <tr key={r.id}>
                    <td style={styles.td}>
                      <span style={{ fontSize: '0.85rem', color: '#666' }}>[ID: {r.product_id}]</span>
                      <br /><b>{r.product_name}</b>
                    </td>
                    <td style={styles.td}>
                      {(() => {
                        const score = Math.max(0, Math.min(5, Number(r.score || 0)));

                        return (
                          <>
                            <span style={{ color: '#ffc107', fontWeight: 'bold' }}>
                              {'★'.repeat(score)}
                              {'☆'.repeat(5 - score)}
                            </span>
                            <span> ({score}점)</span>
                          </>
                        );
                      })()}
                    </td>
                    <td style={styles.td} style={{ ...styles.td, whiteSpace: 'pre-wrap' }}>{r.content}</td>
                    <td style={styles.td}>{r.created_at}</td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        )}

        {/* 5. 문의 탭 */}
        {activeTab === 'qna' && (
          <table style={styles.table}>
            <thead>
              <tr>
                <th style={{ ...styles.th, width: '20%' }}>연관 상품</th>
                <th style={{ ...styles.th, width: '50%' }}>질문 및 답변 내용</th>
                <th style={{ ...styles.th, width: '15%' }}>상태</th>
                <th style={{ ...styles.th, width: '15%' }}>등록일</th>
              </tr>
            </thead>

            <tbody>
              {qnas.length === 0 ? (
                <tr>
                  <td colSpan="4" style={styles.empty}>
                    문의 내역이 없습니다.
                  </td>
                </tr>
              ) : (
                qnas.map((q) => {

                  // 🔥 핵심: 상태 유연하게 처리
                  const isAnswered =
                    q.status === 'answered' ||
                    q.status === 'done' ||
                    q.status === 'Y' ||
                    (q.answer && q.answer.trim() !== '');

                  return (
                    <tr key={q.id}>
                      <td style={styles.td}>
                        <span style={{ fontSize: '0.85rem', color: '#666' }}>
                          [ID: {q.product_id}]
                        </span>
                        <br />
                        {q.product_name}
                      </td>

                      <td style={styles.td}>
                        <div style={{ marginBottom: '8px' }}>
                          <strong style={{ color: '#0056b3' }}>Q.</strong>{' '}
                          <span style={{ whiteSpace: 'pre-wrap' }}>
                            {q.question}
                          </span>
                        </div>

                        {/* 🔥 답변은 상태가 아니라 "내용 기준"으로 표시 */}
                        {q.answer && q.answer.trim() !== '' ? (
                          <div
                            style={{
                              padding: '8px',
                              background: '#f8f9fa',
                              borderRadius: '4px',
                              marginTop: '5px',
                            }}
                          >
                            <strong style={{ color: '#28a745' }}>A.</strong>{' '}
                            <span style={{ whiteSpace: 'pre-wrap', color: '#555' }}>
                              {q.answer}
                            </span>

                            {q.answered_at && (
                              <div
                                style={{
                                  fontSize: '0.8rem',
                                  color: '#888',
                                  marginTop: '4px',
                                }}
                              >
                                답변일: {q.answered_at}
                              </div>
                            )}
                          </div>
                        ) : (
                          <div style={{ color: '#888', marginTop: '5px' }}>
                            답변 대기중
                          </div>
                        )}
                      </td>

                      <td style={styles.td}>
                        <span
                          style={
                            isAnswered
                              ? styles.badgeUnused
                              : styles.badgeUsed
                          }
                        >
                          {isAnswered ? '답변완료' : '답변대기'}
                        </span>
                      </td>

                      <td style={styles.td}>{q.created_at}</td>
                    </tr>
                  );
                })
              )}
            </tbody>
          </table>
        )}

        {/* 6. 찜 탭 (실제 목록 및 상품 가격 연동 완료) */}
        {activeTab === 'wishlist' && (
          <table style={styles.table}>
            <thead>
              <tr>
                <th style={styles.th}>상품 번호(ID)</th>
                <th style={styles.th}>상품명</th>
                <th style={styles.th}>판매 금액</th>
                <th style={styles.th}>찜 추가일</th>
              </tr>
            </thead>
            <tbody>
              {wishlists.length === 0 ? (
                <tr>
                  <td colSpan="4" style={styles.empty}>찜한 상품이 없습니다.</td>
                </tr>
              ) : (
                wishlists.map((w) => (
                  <tr key={w.id}>
                    <td style={styles.td}>{w.product_id}</td>
                    <td style={styles.td}><b>{w.product_name}</b></td>
                    <td style={styles.td}>{Number(w.product_price || 0).toLocaleString()}원</td>
                    <td style={styles.td}>{w.created_at}</td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        )}
      </div>
    </SellerLayout>
  );
};

const styles = {
  container: { maxWidth: '1200px', margin: '0 auto', padding: '0 15px' },
  loading: { padding: '100px', textAlign: 'center' },

  title: {
    marginTop: '20px',
    marginBottom: '20px',
    borderBottom: '2px solid #dee2e6',
    paddingBottom: '10px',
  },

  summary: {
    display: 'flex',
    gap: '10px',
    flexWrap: 'wrap',
    marginBottom: '25px',
  },

  summaryBox: {
    border: '1px solid #dee2e6',
    padding: '15px 10px',
    minWidth: '140px',
    textAlign: 'center',
    background: '#f9f9f9',
    borderRadius: '4px',
    cursor: 'pointer',
    transition: 'all 0.2s',
  },

  linkText: {
    color: '#0056b3',
    textDecoration: 'underline',
  },

  tabs: {
    display: 'flex',
    gap: '5px',
    marginBottom: '15px',
    borderBottom: '1px solid #dee2e6',
    paddingBottom: '1px',
  },

  tab: {
    padding: '10px 16px',
    border: '1px solid #dee2e6',
    borderBottom: 'none',
    background: '#f8f9fa',
    cursor: 'pointer',
    borderTopLeftRadius: '4px',
    borderTopRightRadius: '4px',
    color: '#495057',
  },

  activeTab: {
    padding: '10px 16px',
    border: '1px solid #dee2e6',
    borderBottom: '1px solid #fff',
    background: '#fff',
    cursor: 'pointer',
    fontWeight: 'bold',
    color: '#000',
    borderTopLeftRadius: '4px',
    borderTopRightRadius: '4px',
    position: 'relative',
    bottom: '-1px',
  },

  card: {
    border: '1px solid #dee2e6',
    padding: '20px',
    borderRadius: '8px',
    background: '#fff',
    lineHeight: '1.6',
  },

  table: {
    width: '100%',
    borderCollapse: 'collapse',
    marginTop: '10px',
    background: '#fff',
  },

  th: {
    border: '1px solid #dee2e6',
    padding: '12px 10px',
    background: '#f8f9fa',
    fontWeight: 'bold',
    textAlign: 'left',
  },

  td: {
    border: '1px solid #dee2e6',
    padding: '12px 10px',
    verticalAlign: 'middle',
  },

  empty: {
    textAlign: 'center',
    padding: '50px',
    color: '#666',
  },

  badgeUsed: {
    backgroundColor: '#e2e3e5',
    color: '#383d41',
    padding: '3px 7px',
    borderRadius: '4px',
    fontSize: '0.85rem',
  },

  badgeUnused: {
    backgroundColor: '#d4edda',
    color: '#155724',
    padding: '3px 7px',
    borderRadius: '4px',
    fontSize: '0.85rem',
    fontWeight: 'bold',
  },
};

export default SellerMemberDetail;